<script setup lang="ts">
import { Pencil, Trash2 } from '@lucide/vue'
import { useI18n } from 'vue-i18n'
import { formatCents } from '@/shared/lib'
import type { AssignedRow } from '../model/types'

defineProps<{ row: AssignedRow }>()
const emit = defineEmits<{
  edit: [serviceId: string]
  detach: [serviceId: string]
}>()
const { t } = useI18n()
</script>

<template>
  <div class="flex items-center gap-2 py-2" data-testid="service-row">
    <div class="min-w-0 flex-1">
      <p class="truncate text-sm font-medium text-foreground">{{ row.name }}</p>
      <p class="truncate text-xs text-muted-foreground">
        {{ t('masters.services.row.summary', {
          duration: row.durationMin,
          price: formatCents(row.priceCents),
          buffer: row.bufferMin
        }) }}
      </p>
    </div>
    <button
      type="button"
      class="inline-flex size-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      :aria-label="`${t('masters.services.actions.edit')} ${row.name}`"
      @click="emit('edit', row.serviceId)"
    >
      <Pencil class="size-4" aria-hidden="true" />
    </button>
    <button
      type="button"
      class="inline-flex size-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-destructive/10 hover:text-destructive focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      :aria-label="`${t('masters.services.actions.detach')} ${row.name}`"
      @click="emit('detach', row.serviceId)"
    >
      <Trash2 class="size-4" aria-hidden="true" />
    </button>
  </div>
</template>
